import { useMemo } from 'react'
import { useLocation } from 'react-router'

interface options {
  decode?: boolean
}
export function useUrlSearch<T extends Record<string, any>>(op?: options) {
  const { decode } = op || {}
  const location = useLocation()
  const params = useMemo(() => {
    try {
      const search = location.search.indexOf('?') > -1 ? location.search.slice(1) : location.search
      const params = {}
      if (!search) {
        return params
      }
      search.split('&').forEach((item) => {
        const [key, vallue] = item.split('=')
        params[key] = decode ? decodeURIComponent(vallue) : vallue
      })
      return params
    } catch (err) {
      throw new Error(err)
    }
  }, [decode, location.search])

  return params as T
}
